import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { ClickOutsideModule } from 'ng-click-outside';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { MenubarModule } from 'primeng/menubar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { MegaMenuModule } from 'primeng/megamenu';

import { MiscModule } from '../Misc/misc.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { FilterModule } from '../Filter/filter.module';

import { MasterLayoutComponent } from './components/MasterLayout/master-layout.component';
import { LeftSidebarComponent } from './components/LeftSidebar/left-sidebar.component';
import { TemplateDirective } from './directives/template/template.directive';
import { TabComponent } from './components/Tab/tab.component';
import { RightSidebarComponent } from './components/RightSidebar/right-sidebar.component';
import { TabsComponent } from './components/Tabs/tabs.component';
import { ActionBarComponent } from './components/ActionBar/action-bar.component';
import { NavbarComponent } from './components/Navbar/navbar.component';
import { ImpersonatorBannerComponent } from './components/ImpersonatorBanner/impersonator-banner.component';
import { FooterActionBarComponent } from './components/FooterActionBar/footer-action-bar.component';
import { CompressedNavComponent } from './components/Navbar/CompressedNav/compressed-nav.component';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { ManageLhpListDialogComponent } from './components/LeftSidebar/ManageLhpListDialog/manage-lhp-list-dialog.component';
import { DisplayGroupsApi } from '../../api/displayGroups/display-groups.api';
import { HypeComponent } from './components/Hype/hype.component';
import { TransitionCardTabsComponent } from './components/TransitionCardTabs/transition-card-tabs.component';
import { AgentBannerComponent } from './components/AgentBanner/agent-banner.component';

export const commonLayoutImports = [
    CommonModule,
    RouterModule,
    FormsModule,
    ButtonModule,
    SelectModule,
    ScrollPanelModule,
    TooltipModule,
    MiscModule,
    LocalizationModule,
    MenubarModule,
    MegaMenuModule,
    AutoCompleteModule,
    FilterModule,
    ClickOutsideModule,
    CommonBasicModule,
    CommonFormsModule,
    A11yModule,
    TakeOverModule,
    ScrollingModule,
];
export const commonLayoutDeclarations = [
    MasterLayoutComponent,
    LeftSidebarComponent,
    TemplateDirective,
    RightSidebarComponent,
    TabComponent,
    TabsComponent,
    ActionBarComponent,
    NavbarComponent,
    ImpersonatorBannerComponent,
    FooterActionBarComponent,
    CompressedNavComponent,
    ManageLhpListDialogComponent,
    HypeComponent,
    TransitionCardTabsComponent,
    AgentBannerComponent
];

@NgModule({
    imports: commonLayoutImports,
    declarations: commonLayoutDeclarations,
    exports: [
        MasterLayoutComponent,
        LeftSidebarComponent,
        TemplateDirective,
        RightSidebarComponent,
        TabComponent,
        TabsComponent,
        ActionBarComponent,
        NavbarComponent,
        ImpersonatorBannerComponent,
        FooterActionBarComponent,
        CompressedNavComponent,
        ManageLhpListDialogComponent,
        HypeComponent,
        TransitionCardTabsComponent,
        AgentBannerComponent
    ],
    providers: [
        DisplayGroupsApi
    ]
})
export class LayoutModule { }
